import { getGlobalVal } from '../../utilities/utils'
import './help.scss'

function Help() {
  let sampleCode = `
    <!DOCTYPE html>
    <html lang="en">
      <head>
          <script src="${getGlobalVal('WEB_APP_BASE_URL') || '.'}/web-components/ez-web-components.min.js"></script>
      </head>
      <body>
          <ez-quote></ez-quote>
      </body>
    </html>
  `
  function copyCode(event: any) {
    let target = event.target;
    navigator.clipboard.writeText(sampleCode);

    target.innerText = 'Copied'!

    window.setTimeout(() => {
      target.innerText = 'Copy Code'
    }, 1500)
  }

  return (
    <div className='help-container'>
      <h3>EZQuote Web Component Integration Sample Code</h3>

      <div>
        <span id='btnCopyCode' onClick={copyCode}>Copy Code</span>
        <a target='_blank' href={`./view-ez-quote-wc.html`}>View Standalone</a>
        <pre id='sampleCode'>
          {
            sampleCode
          }
        </pre>
      </div>
    </div>
  )
}

export default Help